<template>
    <div ref="newsContainer" class="w-full flex flex-col box-border p-4 relative">
        <div
            v-if="!loading"
            class="w-full flex flex-col"
        >
            <PublicArticle
                v-for="item in publicNews"
                :article="item"
                :key="item.uid"
            />
        </div>
        <div v-else class="w-full flex flex-col max-h-[600px]">
            <div class="w-full flex flex-col items-center justify-center p-6 box-border bg-white h-lvh">
                <div class="w-full h-[400px] skeleton-loader"></div>
                <div class="w-[80%] h-20 skeleton-loader mt-4"></div>
                <div
                    class="w-full h-10 skeleton-loader"
                    :class="[i === 1 ? 'mt-10' : 'mt-2']"
                    v-for="i in 10"
                    :key="i"
                ></div>
            </div>
        </div>
        <div class="w-full">
            <PublicNewsPagination
                v-if="!loading && hasNews"
                :from="meta.from ?? 0"
                :last-page="meta.last_page"
                :links="links"
                :to="meta.to ?? 0"
                :total="meta.total ?? 0"
                :initial-per-page="meta.per_page"
                :show-per-page-options="false"
                @change="handlePaginationChange"
            />
        </div>
    </div>
</template>

<script setup>
import {onBeforeUnmount, onMounted, onUpdated, ref} from "vue";
import {useNews} from "@/composables/useNews";
import {useAuth} from "@/stores/AuthStore";
import {storeToRefs} from "pinia";
import PublicArticle from "@/components/custom/news/PublicNewsCard.vue";
import PublicNewsPagination from "@/components/custom/news/PublicNewsPagination.vue";

const {getPublicNews} = useNews();
const {organization} = storeToRefs(useAuth());


const publicNews = ref([]);
const loading = ref(false);
const hasNews = ref(false);
const meta = ref({});
const links = ref([]);

const newsContainer = ref(null);

function loadNews(page,perPage) {
    loading.value = true;

    getPublicNews(organization.value.slug, page, perPage).then((response) => {
        publicNews.value = response.data;
        meta.value = response.meta;
        links.value = response.links;
        hasNews.value = response.data.length > 0;
    }).catch((error) => {
        console.log(error);
    }).finally(() => {
        loading.value = false;
    });
}

function handlePaginationChange({page, perPage}) {
    loadNews(page,perPage)
}

function sendHeight() {
    const height = document.body.scrollHeight + 150;
    window.parent.postMessage({ height }, '*');
}

onMounted(() => {
    loadNews(1, 15);
    sendHeight();
    window.addEventListener("resize", sendHeight);
});

onUpdated(() => {
    sendHeight();
});

onBeforeUnmount(() => {
    window.removeEventListener("resize", sendHeight);
});
</script>